import { GET_TASK_TREND, GET_TASK_TREND_SUCCESS, GET_TASK_TREND_ERROR } from './actionTypes';

const initialState = {
  errorGetTaskTrend: '',
  loadingGetTaskTrend: false,
  trend: null,
};

const getTaskTrend = (state = initialState, action) => {
  switch (action.type) {
    case GET_TASK_TREND:
      state = { ...state, loadingGetTaskTrend: true };
      break;
    case GET_TASK_TREND_SUCCESS:
      state = { ...state, loadingGetTaskTrend: false, trend: action.payload.trend };
      break;
    case GET_TASK_TREND_ERROR:
      state = { ...state, errorGetTaskTrend: action.payload, loadingGetTaskTrend: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getTaskTrend;
